const ACTIONS = {
    SHOW_CARD_FORM: 'show-card-form',
    SET_CARD: 'set-card',
    SET_CAPCTHA: 'set-captcha',
    SELECT_PAYMENT_TYPE: 'select-payment-type',
    SET_CAPTCHA_TOKEN: 'set-captcha-token',
    SET_MUTATE: 'set-mutate',
    SHOW_TEST_CARD: 'show-test-card',
};
export default ACTIONS;
